import SEOFriendlyURL from '../../../src/components/content-ai-tools/SEOFriendlyURL';
import ToolsStyleWrapper from '../../../src/components/content-ai-tools/components/ToolsStyleWrapper';

const PublicDiscoveryKeywordsWrapped = () => {
  return <ToolsStyleWrapper component={SEOFriendlyURL} />;
};

export default PublicDiscoveryKeywordsWrapped;
